import { Sachbearbeiter } from '@/types/service-response'

export class SearchAddressEmployee {
  public constructor (
    readonly adressID: number,
    readonly sachbearbeiterID: number,
    readonly adresse: string | null,
    readonly sachbearbeiterName: string | null,
    readonly sachbearbeiterVorname: string | null,
    readonly sachbearbeiterZusatz: string | null,
    readonly sachbearbeiterAktiv: boolean,
    readonly sachbearbeiterAnrede: string | null,
    readonly adresseName: string | null,
    readonly adressePLZ: string | null,
    readonly adresseOrt: string | null,
    readonly genAdresse: string | null
  ) {}

  static createFromResponse (responseData: Sachbearbeiter[]): Array<SearchAddressEmployee> {
    return responseData.map((item: Sachbearbeiter ) => {
      return new SearchAddressEmployee(
        item.AdressID,
        item.SachbearbeiterID,
        item.Adresse,
        item.SachbearbeiterName,
        item.SachbearbeiterVorname,
        item.SachbearbeiterZusatz,
        item.SachbearbeiterAktiv,
        item.SachbearbeiterAnrede,
        item.AdresseName,
        item.AdressePLZ,
        item.AdresseOrt,
        item.GenAdresse
      )
    })
  }
}
